import { useEffect, useState } from "react";
import { useMutation } from "@apollo/client";

import './SupportForm.scss';
import { SEND_EMAIL, SEND_EMAIL_WITH_RECIPIENT } from "../../service/graphql/mutation";
import { subjectList } from "../../service/utils/constants";

interface SupportFormProps {
  darkMode: boolean,
  username: string,
  email: string,
  recipient?: string // Optional recipient email address
};

const SupportForm = (props: SupportFormProps) => {
  const username = props.username;
  const email = props.email;
  const recipient = props.recipient;
  const [accountNo, setAccountNo] = useState('');
  const [address, setAddress] = useState('');
  const [selectedSubject, setSelectedSubject] = useState('');
  const [content, setContent] = useState('');

  const [messageSending, setMessageSending] = useState(false);
  const [isMessageSent, setIsMessageSent] = useState(false);
  const [fadingOut, setFadingOut] = useState(false);

  const [sendEmail, {data: mailRes}] = useMutation(SEND_EMAIL, {
    onError: () => {
      setMessageSending(false);
    },
    errorPolicy: 'all'
  });

  const [sendEmailWithRecipient, {data: mailResWithRecipient}] = useMutation(SEND_EMAIL_WITH_RECIPIENT, {
    onError: () => {
      setMessageSending(false);
    },
    errorPolicy: 'all'
  });

  useEffect(() => {
    if (isMessageSent) setTimeout(() => setFadingOut(true), 10000);
  }, [isMessageSent]);

  useEffect(() => {
    if (fadingOut) {
      setTimeout(() => {
        setIsMessageSent(false);
        setFadingOut(false);
      }, 290);
    }
  }, [fadingOut]);

  const sendEmailAction = () => {
    if (
      accountNo.length > 0 && address.length > 0 &&
      selectedSubject.length > 0 && content.length > 0
    ) {
      if (recipient) {
        // Use the custom recipient mutation
        sendEmailWithRecipient({
          variables: {
            fullname: username,
            emailFrom: email,
            accountID: accountNo,
            address,
            subject: selectedSubject,
            content,
            recipient
          },
          context: {
            apiName: 'cms'
          }
        });
      } else {
        // Use the default mutation
        sendEmail({
          variables: {
            fullname: username,
            emailFrom: email,
            accountID: accountNo,
            address,
            subject: selectedSubject,
            content
          },
          context: {
            apiName: 'cms'
          }
        });
      }
    } else setMessageSending(false);
  };

  useEffect(() => {
    if ((mailRes && mailRes.sendSupportEmail === 'OK') || 
        (mailResWithRecipient && mailResWithRecipient.sendSupportEmail === 'OK')) {
      setIsMessageSent(true);
    }
    setMessageSending(false);
  }, [mailRes, mailResWithRecipient]);

  return (
    <form className={'help-form-wrapper' + (props.darkMode ? ' dark' : '')}>
      <div className='row'>
        <label htmlFor='username'>Name</label>
        <input
          type='text'
          id='username'
          name='username'
          placeholder='Name'
          value={username}
          disabled
        />
        <label htmlFor='phone-email'>Phone no. or Email</label>
        <input
          type='text'
          id='phone-email'
          name='phone-email'
          placeholder='Phone no. or Email'
          value={email}
          title={email}
          disabled
        />
        <label htmlFor='account'>Account name or no.</label>
        <input
          type='text'
          id='account'
          name='account'
          placeholder='Account name or no.'
          value={accountNo}
          onChange={e => {
            const newVal = e.target.value;
            if (newVal.length <= 100) setAccountNo(newVal);
          }}
        />
      </div>
      <label htmlFor='address'>Address</label>
      <input
        type='text'
        id='address'
        name='address'
        placeholder='Address'
        value={address}
        onChange={e => {
          const newVal = e.target.value;
          if (newVal.length < 256) setAddress(newVal);
        }}
      />
      <label htmlFor='subject'>Subject</label>
      <select name='subject' id='subject' onChange={e => setSelectedSubject(e.target.value)}>
        {subjectList.map((opt, idx) =>
          <option disabled={idx === 0} key={'subject-' + idx} value={opt}>{opt}</option>
        )}
      </select>
      <label htmlFor='content'>What would you like?</label>
      <textarea
        id='content'
        name='content'
        rows={3}
        placeholder='What would you like?'
        value={content}
        onChange={e => {
          const newVal = e.target.value;
          if (newVal.length <= 500) setContent(newVal);
        }}
      />
      <div className='row'>
        <div
          className={'submit-btn' + (messageSending ? ' loading' : '')}
          style={{width: '20%'}}
          onClick={evt => {
            evt.preventDefault();
            setMessageSending(true);
            sendEmailAction();
          }}
        >{messageSending ? '' : 'Submit'}</div>
        {isMessageSent && (
          <p className={'thank-you-msg' + (fadingOut ? ' fading' : '')}>
            Thank you for submitting, we will get back to you soon!
          </p>
        )}
      </div>
    </form>
  );
};

export default SupportForm;